export type RemainingTime = {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
};

/**
 * Convert timestamp to object format {days:1, hours:1, minutes:1, seconds:1}
 * @param remainingTime - timestamp representation of the difference between 2 timestamps (milliseconds)
 * @returns RemainingTime object
 */
export const getRemainingTime = (remainingTime: number): RemainingTime => {
    let seconds = Math.floor(remainingTime / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    hours %= 24;
    minutes %= 60;
    seconds %= 60;

    const remainingTimeObj: RemainingTime = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    let showNextUnit = false;

    if (days > 0) {
        remainingTimeObj.days = days;
        showNextUnit = true;
    }

    if (showNextUnit || hours > 0) {
        remainingTimeObj.hours = hours;
        showNextUnit = true;
    }

    if (showNextUnit || minutes > 0) {
        remainingTimeObj.minutes = minutes;
        showNextUnit = true;
    }

    if (showNextUnit || seconds > 0) {
        remainingTimeObj.seconds = seconds;
    }

    return remainingTimeObj;
};

/**
 * Calculates the time difference between 2 timestamps.
 * @param toTimeStamp - future timestamp (milliseconds)
 * @param fromTimeStamp - current timestamp (milliseconds), defaults to Date.now()
 * @returns RemainingTime object or null if toTimeStamp is in the past
 */
export const getDifferenceBetweenTimes = (toTimeStamp: number, fromTimeStamp = Date.now()) => {
    if (toTimeStamp < fromTimeStamp) {
        return null;
    }

    return getRemainingTime(Math.floor(toTimeStamp - fromTimeStamp));
};

/**
 * Returns a countdown value in milliseconds
 * @param dateAndTime - date string
 * @returns number (milliseconds remaining), or null if invalid date
 */
export const getRemainingMSeconds = (dateAndTime: string): number | null => {
    const timestamp = Date.parse(dateAndTime);

    if (!isNaN(timestamp)) {
        const difference = timestamp - Date.now();
        return difference >= 0 ? difference : 0;
    }

    return null;
};
